<template>
  <div class="c-serviceDetailTitle">
    <div class="c-heading">
      <div class="c-heading_row">
        <div
          class="c-heading_icon"
          v-if="serviceDetail.serviceDetail.proFlag"
        >
          <ProIcon width="30px" />
        </div>
        <div
          class="c-heading_icon"
          v-else-if="serviceDetail.serviceDetail.certificationDivinationFlag"
        >
          <DivinationIcon width="30px" />
        </div>
        <div class="c-heading_overview c-overview">
          <h1 v-if="serviceDetail.serviceDetail.overview">
            <p class="c-overview_overview">
              {{ serviceDetail.serviceDetail.overview }}
            </p>
            <p class="c-overview_text">{{ serviceDetail.serviceDetail.catchphrase }}</p>
          </h1>
          <h1 v-else>
            <p class="c-overview_overview">
              {{ serviceDetail.serviceDetail.name }}
            </p>
          </h1>
          <div class="c-heading_labels">
            <div
              class="c-phoneLabel"
              v-if="serviceDetail.serviceDetail.serviceClass === serviceClass.phone"
            >
              <span class="c-phoneLabel_label">電話相談</span>
            </div>
            <div
              class="c-shipmentLabel"
              v-if="serviceDetail.serviceDetail.shipmentFlag"
            >
              <span class="c-shipmentLabel_label">物品配送可能</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-performance">
      <div class="c-performance_row">
        <div class="c-performance_item c-performance_rating">
          <div class="c-performance_label">
            評価
          </div>
          <div class="c-performance_content">
            <span
              class="c-rating"
              v-if="serviceDetail.serviceDetail.rating"
            >
              <c-rating-stars
                :size="14"
                :score="serviceDetail.serviceDetail.rating.indicator"
                class="c-ratingPc"
                v-if="isPC"
              />
              <coconala-icon
                name="star"
                class="c-ratingSp"
                :class="{ 'c-ratingSp-active': serviceDetail.serviceDetail.rating.indicator }"
                v-else-if="isSP || isTB"
              />
            </span>

            <span v-if="serviceDetail.serviceDetail.rating.indicator">
              <strong>{{ displayFixed(serviceDetail.serviceDetail.rating.indicator) }}</strong>
            </span>
            <span v-else>
              -
            </span>
            <span v-if="serviceDetail.serviceDetail.rating.ratingCount">
              （{{ serviceDetail.serviceDetail.rating.ratingCount }}）
            </span>
          </div>
        </div>
        <div class="c-performance_item c-performance_sales">
          <div class="c-performance_label">
            販売実績
          </div>
          <div class="c-performance_content">
            <strong>{{ serviceDetail.serviceDetail.performanceCount }}</strong>件
          </div>
        </div>
      </div>

      <div class="c-performance_row">
        <div class="c-performance_item c-performance_stock">
          <div class="c-performance_label">
            残り
          </div>
          <div class="c-performance_content">
            <strong>{{ serviceDetail.serviceDetail.orderStockCount }}</strong>枠 / お願い中：<strong>{{ serviceDetail.serviceDetail.openedTalkroomCount }}</strong>人
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProIcon from '~/components/molecules/ProIcon'
import DivinationIcon from '~/components/molecules/Divination'
import CRatingStars from '~/components/atoms/CRatingStars'

// vuex
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'serviceDetailTitle',
  components: {
    ProIcon,
    CRatingStars,
    DivinationIcon
  },
  props: {
    serviceDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('constants', ['serviceClass']),
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP'])
  },
  methods: {
    displayFixed(value, digit = 1) {
      return value.toFixed(digit)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceDetailTitle {
}

.c-heading {
  display: flex;

  &_row {
    display: flex;
  }

  &_icon {
    margin-right: 8px;

    /deep/ .dropdown-menu {
      z-index: z(sub-header, tooltip);
    }
  }

  &_overview {
  }

  &_labels {
    margin-bottom: 12px;
  }
}

.c-phoneLabel {
  display: inline-block;
  margin-right: 8px;

  &_label {
    display: inline-block;
    font-size: 10px;
    height: 20px;
    line-height: 18px;
    padding: 0 8px;
    color: $color-orange-500;
    text-align: center;
    border: 1px solid $color-orange-500;
  }
}

.c-shipmentLabel {
  display: inline-block;
  margin-right: 8px;

  &_label {
    display: inline-block;
    font-size: 10px;
    height: 20px;
    line-height: 18px;
    padding: 0 8px;
    color: $color-gray-700;
    text-align: center;
    border: 1px solid $color-gray-700;
  }
}

.c-overview {
  &_overview {
    margin: 0;
    font-weight: bold;
    font-size: 24px;
    line-height: 31px;
  }

  &_text {
    margin: 0;
    color: $color-gray-700;
    font-weight: normal;
    font-size: 19px;
  }
}

.c-performance {
  display: flex;
  margin-top: 4px;

  &_row {
    display: flex;
  }

  &_item {
    display: inline-block;
    margin-right: 20px;
    line-height: 1;
  }

  &_label {
    margin-right: 4px;
    padding: 4px 8px 5px;
    font-size: 12px;
    display: inline-block;
    background: $color-gray-50;
  }

  &_content {
    display: inline-block;
    top: 1px;
    position: relative;
  }

  .c-ratingStars {
    top: 1px;
  }

  .c-rating {
    display: inline-block;
    min-width: 76px;
  }

  .c-ratingSp {
    vertical-align: -1px;
    color: $color-gray-300;

    &-active {
      color: $ds2-color-star;
    }
  }
}

@media (max-width: breakpoint(ServiceDetail, M)) {
  .c-heading {
    flex-direction: column;

    &_row:nth-child(n + 2) {
      margin-top: 4px;
    }
  }

  .c-overview {
    &_overview {
      font-size: 17px;
      line-height: 24px;
    }

    &_text {
      font-size: 12px;
    }
  }

  .c-performance {
    flex-direction: column;

    &_row:nth-child(n + 2) {
      margin-top: 4px;
    }

    .c-rating {
      min-width: 12px;
    }
  }
}
</style>
